import dayjs from "dayjs";
import { useSidebar } from "../../context/sidebarContext";

const FreeTrialAccountCard = ({
  trialStartDate,
  trialEndDate,
  isFreeTrial = false,
}) => {
  const { setIsOpenUpgradeDialog } = useSidebar();

  const start = dayjs(trialStartDate);
  const end = dayjs(trialEndDate);
  const today = dayjs();

  const totalTrialDays = end.diff(start, "day");

  // FIX: ceiling for days left
  const daysLeft = Math.ceil(end.diff(today, "hour") / 24);

  const progress = Math.min(
    100,
    ((totalTrialDays - daysLeft) / totalTrialDays) * 100,
  );

  return (
    <div
      className={`hidden xl:flex p-4 bg-white border border-gray-200 rounded-lg flex-row gap-2  ${isFreeTrial ? "" : daysLeft > 0 ? " xl:flex-col" : ""}`}
    >
      <div
        className={`${isFreeTrial ? "w-[40%]" : daysLeft > 0 ? "w-full " : "w-[40%]"}`}
      >
        <h2 className="text-gray-500 font-medium text-xs my-0 py-0">
          {isFreeTrial ? "Free Trial" : "Subscription"}
        </h2>

        <p className="text-red-500 text-xs font-semibold my-0 py-0 inline-block">
          {daysLeft > 0
            ? isFreeTrial
              ? `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`
              : `Ends in ${daysLeft} day${daysLeft === 1 ? "" : "s"}`
            : isFreeTrial
              ? "Expired"
              : "Expired"}
        </p>
      </div>

      <div className={`${isFreeTrial ? "w-[70%]" : "w-full"}`}>
        <a
          onClick={() => setIsOpenUpgradeDialog(true)}
          className="w-full flex items-center justify-center py-[8px] px-1 border border-[#007A78] rounded-md text-teal-600 font-semibold hover:bg-teal-50 focus:outline-none focus:ring-2 focus:ring-[#007A78] focus:ring-opacity-50 cursor-pointer text-xs"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-2 text-teal-600"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
            <path
              fillRule="evenodd"
              d="M18 9H2v6a2 2 0 002 2h12a2 2 0 002-2V9zm-7 4a1 1 0 100-2 1 1 0 000 2z"
              clipRule="evenodd"
            />
          </svg>

          {isFreeTrial ? "Upgrade Plan" : "Manage Plan"}
        </a>
      </div>
    </div>
  );
};

export default FreeTrialAccountCard;
